import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'এই পেজটি রিপোর্ট করুন',
  title: 'এই পেজের কোনো সমস্যা রিপোর্ট করুন',
  reasons: {
    'inaccurate-or-fabricated': 'ভুল বা বানানো তথ্য',
    'wrong-product': 'পণ্যগুলো পেজের সঙ্গে মেলে না',
    'sexually-explicit': 'স্পষ্ট যৌন বিষয়বস্তু',
    'regulated-product': 'প্রেসক্রিপশন-নির্ভর বা নিয়ন্ত্রিত পণ্য',
    'dangerous-product': 'বিপজ্জনক পণ্য',
    'ip-infringement': 'আমার অধিকার লঙ্ঘন করে (ট্রেডমার্ক/কপিরাইট)',
    other: 'অন্য কিছু',
  },
  detail: 'বিস্তারিত (ঐচ্ছিক)',
  submit: 'রিপোর্ট পাঠান',
  cancel: 'বাতিল করুন',
  sent: 'ধন্যবাদ। আমরা ২৪ ঘণ্টার মধ্যে রিপোর্টগুলো পর্যালোচনা করি।',
  failed: 'রিপোর্টটি পাঠানো যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
};
